document.addEventListener('DOMContentLoaded', function () {
    const step1 = document.getElementById('step1');
    const step2 = document.getElementById('step2');
    const step3 = document.getElementById('step3');
    //const cnpjForm = document.getElementById('cnpjForm');
    const cnpjInput = document.getElementById('cnpj');
    const checkCNPJButton = document.getElementById('checkCNPJ');
    const formDiv = document.getElementById('form_data');
    const backToStep1Button = document.getElementById('backToStep1');
    const toStep3Button = document.getElementById('toStep3');
    const backToStep2Button = document.getElementById('backToStep2');
    const personalForm = document.getElementById('personalForm');
    const progressSteps = document.querySelectorAll('.progress-step');


    document.getElementById("cnpj").addEventListener("input", function (e) {
        let value = e.target.value.replace(/\D/g, ""); // só números

        // aplica a máscara
        if (value.length > 2) {
            value = value.replace(/^(\d{2})(\d)/, "$1.$2");
        }
        if (value.length > 5) {
            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        }
        if (value.length > 8) {
            value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
        }
        if (value.length > 12) {
            value = value.replace(/(\d{4})(\d)/, "$1-$2");
        }

        e.target.value = value;
    });


    function updateProgress(step) {
        progressSteps.forEach((progressStep, index) => {
            if (index < step - 1) {
                progressStep.classList.add('completed');
                progressStep.classList.remove('active');
            } else if (index === step - 1) {
                progressStep.classList.add('active');
                progressStep.classList.remove('completed');
            } else {
                progressStep.classList.remove('completed', 'active');
            }
        });
    }

    checkCNPJButton.addEventListener('click', async function () {
        let cnpjValid = validarCNPJ(cnpjInput.value);
        var messageDiv = document.getElementById('msg_error');

        if (cnpjInput.value && cnpjValid) {
            const cnpjSanitized = cnpjInput.value.replace(/[^\d]/g, '');

            // 1. Valida se o CNPJ já está cadastrado na base
            console.log('cnpjInput.value', cnpjInput.value);
            
            const cnpjExists = await verifyClientByCNPJ(cnpjInput.value);

            // if (cnpjExists) {
            //     if (typeof displayMessage === 'function') {
            //         displayMessage('Este CNPJ já está cadastrado em nossa loja.', 'error');
            //     } else if (messageDiv) {
            //         messageDiv.innerText = 'Este CNPJ já está cadastrado em nossa loja.';
            //     }
            //     return; // Interrompe a execução para não prosseguir
            // }

            // 2. Se não existir, prossegue com a busca dos dados do CNPJ
            const content_filiais = document.getElementById('content_filiais');
            if (content_filiais) {
                content_filiais.classList.remove('active');
            }

            try {
                const response = await fetch(`https://api.cnpja.com.br/office/${cnpjSanitized}?strategy=CACHE_IF_ERROR&registrations=BR`, {
                    method: 'GET',
                    headers: {
                        authorization: 'f22fdacf-7c77-41a1-8f3f-6c59b979c8a0-8cc826a7-c308-4654-8322-b23de3059043',
                    },
                });

                const data = await response.json();

                if (data) {
                    if (data?.status?.text === 'Ativa') {
                        formDiv.innerHTML = `
                        <div class="form_group">
                          <div>Inscrição Estadual<strong id='inscricaoEstadual'>${data.registrations && data.registrations.length > 0
                                ? data.registrations[0].number
                                : 'Isento'
                            }</strong></div>
                          <div>Razão Social <strong id='company'>${data.company.name}</strong></div>
                        </div>
                        <div class="form_group">
                          <div>CEP <strong id='zip'>${data.address.zip}</strong></div>
                          <div>Estado <strong id='state'>${data.address.state}</strong></div>
                        </div>
                        <div class="form_group">
                          <div>Endereço <strong id='street'>${data.address.street}</strong></div>
                          ${data.address.number == "S/N"
                                ? "<div>Número<input type='text' id='number_input' value='' /></div>"
                                : "<div>Número <strong id='number'>" + data.address.number + "</strong></div>"}                             
                        </div>
                        <div class="form_group">
                          <div>Bairro <strong id='bairro'>${data.address.district ? data.address.district : ''}</strong></div>
                          <div>Cidade <strong id='city'>${data.address.city}</strong></div>                              
                        </div>
                        <div class="form_group">                             
                          <div>Complemento <strong id='complemento'>${data.address.details ? data.address.details : ''}</strong></div>                              
                        </div>
                    `;

                        const url = new URL(window.location.href);
                        if (url.hash === '#empresa') {
                            const idFiliais = data.company.id;
                            const responseFiliais = await fetch(`https://api.cnpja.com.br/company/${idFiliais}`, {
                                method: 'GET',
                                headers: {
                                    authorization: 'f22fdacf-7c77-41a1-8f3f-6c59b979c8a0-8cc826a7-c308-4654-8322-b23de3059043',
                                },
                            });

                            const dataFiliais = await responseFiliais.json();
                            const filiais = dataFiliais.offices;
                            const listFiliais = document.getElementById('list_filiais');

                            if (listFiliais) {
                                listFiliais.innerHTML = '';

                                if (filiais) {
                                    filiais?.forEach((filial) => {
                                        const filialDiv = document.createElement('div');
                                        filialDiv.innerHTML = `<div>CNPJ <b>${filial.taxId}</b></div>
                                      <br><div>Fundada <b>${filial.founded}</b></div>
                                      <br><div>Status <b>${filial.status?.text}</b></div>`;
                                        listFiliais.appendChild(filialDiv);
                                    });

                                    if (content_filiais) {
                                        content_filiais.classList.add('active');
                                    }
                                }
                            }
                        }

                        step1.classList.remove('form-step-active');
                        step2.classList.add('form-step-active');
                        updateProgress(2);
                        if (messageDiv) messageDiv.innerText = '';
                    } else {
                        if (messageDiv) messageDiv.innerText = 'CNPJ inativo.';
                    }
                } else {
                    if (messageDiv) messageDiv.innerText = 'CNPJ não encontrado.';
                }
            } catch (error) {
                console.error('Erro:', error);
            }
        } else {
            if (messageDiv) messageDiv.innerText = 'Por favor, insira um CNPJ válido.';
        }
    });

    backToStep1Button.addEventListener('click', function () {
        step2.classList.remove('form-step-active');
        step1.classList.add('form-step-active');
        updateProgress(1);
    });

    toStep3Button.addEventListener('click', function () {
        var number_input = document.getElementById('number_input');

        if (number_input && number_input?.value === "") {
            return number_input.style.border = '1px solid red';
        }
        else if (number_input) {
            number_input.style.border = 'none';
        }
        step2.classList.remove('form-step-active');
        step3.classList.add('form-step-active');
        updateProgress(3);
    });

    backToStep2Button.addEventListener('click', function () {
        step3.classList.remove('form-step-active');
        step2.classList.add('form-step-active');
        updateProgress(2);
    });

    personalForm.addEventListener('submit', async function (event) {
        event.preventDefault();

        const firstName = document.getElementById('firstName').value;
        const perfil = document.getElementById('perfil').value;
        const porte = document.getElementById('porte').value;
        const segmentos = document.getElementById('segmentos').value;

        const conheceu = document.getElementById('conheceu').value;
        const remarketing = document.getElementById('remarketing').checked;

        const lastName = document.getElementById('lastName').value;
        const emailContact = document.getElementById('emailContact').value;
        const emailnf = document.getElementById('emailnf').value;
        const email = document.getElementById('email').value;
        const cargo = document.getElementById('cargo').value;
        const phone = document.getElementById('phone');
        const phoneContact = document.getElementById('phoneCel');
        const cnpjMatriz = document.getElementById('cnpj').value;

        const address1 = document.getElementById('street').innerText;
        const bairro = document.getElementById('bairro').innerText;
        const companyAd = document.getElementById('company').innerText;
        const numberField = document.getElementById('number')?.innerText;
        const numberInput = document.getElementById('number_input')?.value;
        const state = document.getElementById('state').innerText;
        const city = document.getElementById('city').innerText;
        const zip = document.getElementById('zip').innerText;
        const complemento = document.getElementById('complemento').innerText;
        const inscricaoEstadual = document.getElementById('inscricaoEstadual').innerText;

        const isExist = await verifyClient(email);
        const isLogged = document.getElementById('isLogged').innerText;
        const userId = document.getElementById("isLogged")?.dataset.userid;

        if (!isLogged && isExist) {
            console.log("Já existe :/");
            displayMessage('Email já cadastrado', "error");
            return;
        }
        console.log('phone', phone?.value?.length);


        if (phoneContact?.value?.length < 14) {
            displayMessage('Telefone celular obrigatório. O número deve conter no mínimo 10 dígitos, considerando o DDD.', "error");
            return;
        }

        const url = baseUrl + (isLogged ? `2025-07/graphql.json` : '2024-04/customers.json');
        const headers = {
            'Content-Type': 'application/json',
            'apiKey': apiPassword
        };
        if (isLogged) {
            const query = `
            mutation customerUpdate($input: CustomerInput!) {
                customerUpdate(input: $input) {
                customer {
                    id
                    firstName
                    lastName
                    email
                    phone
                    metafields(first: 10) {
                    edges {
                        node {
                        namespace
                        key
                        value
                        }
                    }
                    }
                }
                userErrors {
                    field
                    message
                }
                }
            }
            `;

            const variables = {
                input: {
                    id: `gid://shopify/Customer/${userId}`, // ID obrigatório no formato GID
                    firstName,
                    lastName,
                    email,
                    phone: formatPhoneSend(phoneContact),
                    addresses: [
                        {
                            address1: `${bairro}, ${address1}, ${numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField}`,
                            address2: `${complemento}`,
                            city,
                            province: state,
                            phone: formatPhoneSend(phoneContact),
                            zip,
                            lastName: cnpjMatriz,
                            firstName: `${firstName} ${lastName}`,
                            country: "Brazil",
                            company: companyAd
                        }
                    ],
                    metafields: [
                        {
                            namespace: "custom",
                            key: "inscricao_estadual",
                            type: "single_line_text_field",
                            value: inscricaoEstadual
                        },
                        {
                            namespace: "custom",
                            key: "cnpj",
                            type: "single_line_text_field",
                            value: cnpjMatriz
                        },
                        {
                            namespace: "custom",
                            key: "bairro",
                            type: "single_line_text_field",
                            value: bairro
                        },
                        {
                            namespace: "custom",
                            key: "logradouro",
                            type: "single_line_text_field",
                            value: address1
                        },
                        {
                            namespace: "custom",
                            key: "numero",
                            type: "single_line_text_field",
                            value: `${numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField}`
                        },
                        {
                            namespace: "custom",
                            key: "nome_da_empresa",
                            type: "single_line_text_field",
                            value: companyAd
                        },
                        {
                            namespace: "custom",
                            key: "aprovado",
                            type: "boolean",
                            value: "false"
                        },
                        {
                            namespace: "custom",
                            key: "perfil_do_cadastro",
                            type: "single_line_text_field",
                            value: perfil
                        },
                        {
                            namespace: "custom",
                            key: "porte_da_empresa",
                            type: "single_line_text_field",
                            value: porte
                        },
                        {
                            namespace: "custom",
                            key: "segmento",
                            type: "single_line_text_field",
                            value: segmentos
                        },
                        {
                            namespace: "custom",
                            key: "onde_conheceu_a_ricambi",
                            type: "list.single_line_text_field",
                            value: JSON.stringify([conheceu])
                        },
                        {
                            namespace: "custom",
                            key: "permissao_ativacao_marketing",
                            type: "boolean",
                            value: remarketing ? "true" : "false"
                        },
                        {
                            namespace: "custom",
                            key: "email_contact",
                            type: "single_line_text_field",
                            value: emailContact
                        },
                        {
                            namespace: "custom",
                            key: "e_mail_nf",
                            type: "single_line_text_field",
                            value: emailnf
                        },
                        {
                            namespace: "custom",
                            key: "phone_contact",
                            type: "single_line_text_field",
                            value: phone?.value?.length > 9 ? formatPhoneSend(phone) : ''
                        },
                        {
                            namespace: "custom",
                            key: "cargo",
                            type: "single_line_text_field",
                            value: cargo
                        }
                    ]
                }
            };

            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    query,
                    variables
                })
            }).then(response => response.json())
                .then(data => {
                    if (!data) return;

                    console.log('register: ', data);


                    if (data.errors) {
                        const errorStr = Object.entries(data.errors)
                            .map(([key, value]) => `${key}: ${value[0]}`)
                            .join(', ');

                        displayMessage(errorStr);
                    }

                    const customerId = userId;

                    if (customerId) {
                        console.log('Creating company...');

                        createCompany(customerId, companyAd, firstName, lastName, address1, '', city, state, zip, 'BR')
                    }

                })
                .catch(error => console.error('Erro:', error));
        }
        else {
            const body = {
                customer: {
                    "first_name": firstName,
                    "last_name": lastName,
                    "email": email,
                    "phone": '',
                    "verified_email": true,
                    "email_marketing_consent": {
                        "state": "subscribed",
                        "opt_in_level": "single_opt_in",
                        "consent_updated_at": null
                    },
                    "addresses": [{
                        "address1": bairro + ", " + address1 + ", " + (numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField),
                        "address2": complemento,
                        "city": city,
                        "province": state,
                        "phone": phone?.value?.length > 9 ? formatPhoneSend(phone) : formatPhoneSend(phoneContact),
                        "zip": zip,
                        "last_name": cnpjMatriz,
                        "first_name": firstName + ' ' + lastName,
                        "country": 'Brazil',
                        "company": companyAd
                    }],
                    "metafields": [
                        {
                            "namespace": "custom",
                            "key": "bairro",
                            "type": "single_line_text_field",
                            "value": bairro
                        },
                        {
                            "namespace": "custom",
                            "key": "logradouro",
                            "type": "single_line_text_field",
                            "value": address1
                        },
                        {
                            "namespace": "custom",
                            "key": "numero",
                            "type": "single_line_text_field",
                            "value": `${numberInput != 'undefined' && numberInput != undefined ? numberInput : numberField}`
                        },
                        {
                            "namespace": "custom",
                            "key": "inscricao_estadual",
                            "type": "single_line_text_field",
                            "value": inscricaoEstadual
                        },
                        {
                            "namespace": "custom",
                            "key": "cnpj",
                            "value": cnpjMatriz,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "nome_da_empresa",
                            "value": companyAd,
                            "type": "single_line_text_field"
                        },

                        {
                            "namespace": "custom",
                            "key": "aprovado",
                            "value": false,
                            "type": "boolean"
                        },
                        {
                            "namespace": "custom",
                            "key": "perfil_do_cadastro",
                            "value": perfil,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "porte_da_empresa",
                            "value": porte,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "segmento",
                            "value": segmentos,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "onde_conheceu_a_ricambi",
                            "value": JSON.stringify([conheceu]),
                            "type": "list.single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "permissao_ativacao_marketing",
                            "value": remarketing,
                            "type": "boolean"
                        },
                        {
                            "namespace": "custom",
                            "key": "email_contact",
                            "value": emailContact,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "e_mail_nf",
                            "value": emailnf,
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "phone_contact",
                            "value": formatPhoneSend(phoneContact),
                            "type": "single_line_text_field"
                        },
                        {
                            "namespace": "custom",
                            "key": "cargo",
                            "value": cargo,
                            "type": "single_line_text_field"
                        }
                    ]
                }
            };

            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body)
            })
                .then(response => response.json())
                .then(data => {
                    if (!data) return;

                    if (data.errors) {
                        const errorStr = Object.entries(data.errors)
                            .map(([key, value]) => `${key}: ${value[0]}`)
                            .join(', ');

                        displayMessage(errorStr);
                    }

                    const customerId = data.customer.id;

                    if (customerId) {
                        console.log('Creating company...');

                        createCompany(customerId, companyAd, firstName, lastName, address1, '', city, state, zip, 'BR')
                    }

                })
                .catch(error => console.error('Erro:', error));
        }

    });

});


